<template>
    <template v-for="(value, key) in optionItemList">
        <input name="option" :value="value.id" :id="value.id" type="checkbox" v-model="selectedOption"  v-on:change='$emit("option", selectedOption)'>
        <label :for="key">{{value.name}}</label>
    </template>
</template>

<script>
    import { ref } from 'vue'
    export default ({
        props: {
            // 引数の受け
            master : {type: Object, require: true},
            condition: {type: Object, require: true},
        },
        setup (props) {
            const selectedOption = ref(props.condition.selectedOption.value)

            // セットアップ。初期実行
            const optionItemList = JSON.parse(props.master.optionItemList)
            return {
                optionItemList,
                selectedOption,
            }
        },
        emits: ['option']
    })
</script>